<template>
  <div class="panel panel-right panel-cover panel" id='panel-right-demo'>
    <div class="content-block top" style="padding: 0.6rem;">
      <p style="font-size: 0.6rem;border-bottom: 1px solid;">为您找到<span style="color: #0894ec;">{{queryTotal.total}}</span>条结果</p>
      <div class="content-block-title" style="margin-top: -0.3rem">产品类别</div>
      <div class="list-block bottom">
        <ul class="border-bottom">
          <li class="item-content">
            <div class="item-inner">
              <div class="item-input">
                <select v-model="categorySelected">
                  <option disabled value="" selected>请选择 ▼</option>
                  <option v-if="currentCategory" ><span style="font-size:0.7rem">{{this.$route.query.label}}</span></option>
                  <!--                  <option v-if="currentCategory" :value="tempOption.value"><span style="font-size:0.7rem">{{this.$route.query.label}}</span></option>-->
<!--                  <option v-else v-for="tar in categoriesOptions" :value="tar.value"><span style="font-size:0.7rem">{{tar.text}}</span></option>-->
                </select>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-for="item in selection">
        <div class="content-block-title top">{{item.attributeName}}</div>
        <div class="list-block bottom">
          <ul class="border-bottom">
            <li class="item-content list">
              <label class="label-checkbox label" v-for="(val, inx) in item.filterItems" v-if="inx<3">
                <input type="checkbox" name="my-checkbox" :value=val v-model="itemSel">
                <div class="item-media checkbox-text" :class="{select: itemSel.includes(val)}"><div class="span-text">{{val.dictValue}}</div></div>
              </label>
            </li>
            <li class="item-content list" v-if="item.filterItems.length>3">
              <label class="label-checkbox label" v-for="(val, inx) in item.filterItems.slice(3)" v-if="inx<3">
                <input type="checkbox" name="my-checkbox" :value=val v-model="itemSel">
                <div class="item-media checkbox-text" :class="{select: itemSel.includes(val)}"><div class="span-text">{{val.dictValue}}</div></div>
              </label>
            </li>
            <li class="item-content list" v-if="item.filterItems.length>6">
              <label class="label-checkbox label" v-for="(val, inx) in item.filterItems.slice(6)" v-if="inx<3">
                <input type="checkbox" name="my-checkbox" :value=val v-model="itemSel">
                <div class="item-media checkbox-text" :class="{select: itemSel.includes(val)}"><div class="span-text">{{val.dictValue}}</div></div>
              </label>
            </li>
            <li class="item-content list" v-if="item.filterItems.length>9">
              <label class="label-checkbox label" v-for="(val, inx) in item.filterItems.slice(9)" v-if="inx<3">
                <input type="checkbox" name="my-checkbox" :value=val v-model="itemSel">
                <div class="item-media checkbox-text" :class="{select: itemSel.includes(val)}"><div class="span-text">{{val.dictValue}}</div></div>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <nav class="bar bar-tab" style="    bottom: auto;">
      <a class="tab-item active" @click="reset">
        <span class="tab-label">重置</span>
      </a>
      <a class="tab-item close-panel" style="background-color: #0894ec;">
        <span class="confirm" @click="clickConfirm">确定</span>
      </a>
    </nav>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import emkt from '../../emkt.js'
  import $ from 'jquery'
  export default {
    created () {
      this.matchData()
      this.reset()
    },
    mounted () {
      let enterprise = $('#panel-right-demo')
      enterprise.on('open', function () {
        emkt.setStoreItem('panelFilterFlag', true)
      })
      enterprise.on('closed', function () {
        emkt.setStoreItem('panelFilterFlag', false)
      })
      this.init()
    },
    data () {
      return {
        categorySelected: '',
        itemSel: [],
        categoryOptions: [],
        currSelection: [],
        search: {},
        currentCategory: '',
        tempOption: [],
        categoriesOptions: [],
        categoryId: '',
        queryParams: ''
      }
    },
    computed: {
      ...mapState([
        'routerSrc', 'queryTotal'
      ]),
      selection () {
        let options = this.categoryOptions
        if (this.categorySelected === '') {
          this.categorySelected = this.$route.query.label
          this.currentCategory = this.$route.query.id
          $.openPanel('#panel-right-demo')
        }
        console.log('tempOption', this.tempOption)
        console.log(options)
        for (var i in options) {
          if (this.categorySelected === options[i].text) {
            this.currSelection = options[i].children
            this.categoryId = options[i].id
            this.tempOption = options[i]
            return options[i].children
          }
        }
      }
    },
    methods: {
      ...mapMutations([
        'QUERY_PARAMS_STORE'
      ]),
      reset () {
        let src = this.routerSrc.name
        if (src === 'home' || src === 'category') {
          this.categoryId = ''
          this.categorySelected = ''
        }
        this.itemSel = []
        this.queryParams = ''
      },
      matchData () {
        let meta = emkt.getEmktMetaData()
        let categories = meta.categoriesMap
        let match = meta.categoryIdToFilterAttributes
        let attr = meta.categoryAttrsMap
        for (var k in categories) {
          let val = match[k]
          if (val) {
            let key = categories[k].categoryLabel
            let valAttr = []
//            let rows = ''
            let rowsCount = 0
            for (var i in val) {
              let objAttr = {}
              objAttr['attributeName'] = attr[k][val[i].attributeName].categoryAttrLabel
              let temp = val[i].filterItems
              temp.forEach((data) => {
                data['attributeNameSrc'] = val[i].attributeName
              })
              objAttr['filterItems'] = temp
              valAttr.push(objAttr)
              rowsCount = Math.ceil(valAttr.length / 3)
            }
            let obj = {'id': categories[k].categoryId, 'text': key, 'value': key, 'children': valAttr, 'rowsCount': rowsCount}
            this.categoryOptions.push(obj)
          }
        }
        if (this.$route.query.search) {
          this.search = JSON.parse(this.$route.query.search)
        }
      },
      queryHandler () {
        let items = this.itemSel
//        let options = this.categoryOptions
//        for (var k in options) {
//          if (this.categorySelected === options[k].text) {
//            this.currSelection = options[k].children
//            this.categoryId = options[k].id
//          }
//        }
        var obj = {}
        for (var i in items) {
          var arr = []
          for (var j in items) {
            if (items[i].attributeNameSrc === items[j].attributeNameSrc) {
              arr.push(items[j].dictKey)
              obj[items[i].attributeNameSrc] = arr
            }
          }
        }
        let queryParam = {}
        if (this.categoryId !== '') {
          queryParam.filterConditions = obj
          this.queryParams = obj
          queryParam.categoryId = this.categoryId
        }
        if (this.search.categoryId) {
          this.categoryId = this.search.categoryId
        }
        queryParam.keywordChosen = $('#searchGoods').val()
        queryParam.tagIds = this.search.tagIds
        queryParam.fromIndex = 0
        queryParam.promotionGuid = this.search.promotionGuid
        this.QUERY_PARAMS_STORE(queryParam)
      },
      clickConfirm () {
        this.queryHandler()
      },
      selectChanged (val) {
        let queryParam = {}
        let id = 0
        let sel = this.categorySelected
        this.categoryOptions.forEach(data => {
          if (data.value === sel) {
            id = data.id
          }
        })
        if (this.categoryId !== '') {
          queryParam.categoryId = this.categoryId
        }
        if (id) {
          this.categoryId = id
          queryParam.categoryId = id
        }
        queryParam.keywordChosen = $('#searchGoods').val()
        queryParam.tagIds = this.search.tagIds
        queryParam.fromIndex = 0
        queryParam.promotionGuid = this.search.promotionGuid
        this.QUERY_PARAMS_STORE(queryParam)
        // this.itemSel = []
      },
      init () {
        this.categoryId = ''
        this.itemSel = []
        let query = this.$route.query
        let id = ''
        if (query) {
          if (query.categoryId) {
            id = parseInt(query.categoryId)
          } else {
            id = parseInt(query.id)
          }
          if (id) {
            this.categoryId = id
          }
          if (id === 5 || id === 8 || id === 14 || id === 7 || id === 9) {
            let ret = {}
            let cs = ''
            let cc = ''
            let ci = ''
            this.categoryOptions.filter((e, index, self) => {
              if (e.id === id) {
                ret = e
                cs = e.text
                cc = e.text
                ci = e.id
                return ret
              }
            })
            this.categorySelected = cs
            this.currentCategory = cc
            this.categoryId = ci
            this.tempOption = ret
            if (query.filterName && query.filterName !== 'promotionGuid') {
              for (let i in ret.children) {
                for (let j in ret.children[i].filterItems) {
                  if (ret.children[i].filterItems[j].attributeNameSrc === query.filterName && ret.children[i].filterItems[j].dictKey === parseInt(query.filterValue)) {
                    this.itemSel.push(ret.children[i].filterItems[j])
                  }
                }
              }
            }
            $.openPanel('#panel-right-demo')
          }
        }
        let src = this.routerSrc.name
        let i = this.categoryId
        if (i !== 5 && i !== 8 && i !== 14 && i !== 7 && i !== 9 && (src === 'home' || src === 'category')) {
          this.categorySelected = ''
          this.currentCategory = ''
        }
      }
    },
    watch: {
      itemSel: {
        handler: 'queryHandler',
        deep: true
      },
      'routerSrc': function () {
        /*
          if the route comes from category detail,
          checks category default on the base of the query params of router
         */
        let cur = this.routerSrc.query
        let currentCategory
        if (cur) {
          currentCategory = cur.label
          if (currentCategory) {
            this.currentCategory = currentCategory
            this.categorySelected = this.currentCategory
            this.categoryId = cur.id
            let options = this.categoryOptions
            if (options) {
              options.forEach(data => {
                if (data.text === currentCategory) {
                  let obj = {'text': data.text, 'value': data.text, 'children': data.children}
                  this.tempOption = obj
                }
              })
            }
          } else {
            this.reset()
          }
//          if (this.routerSrc.name !== 'home' && (this.routerSrc.query.id !== 'undefined' && this.routerSrc.query.id !== 2 && this.routerSrc.query.id !== 3 && this.routerSrc.query.id !== 12 && this.routerSrc.query.id !== 1 && this.routerSrc.query.id !== 6 && this.routerSrc.query.id !== 7)) {
//            $.openPanel('#panel-right-demo')
//          }
        }
      },
      '$route': function () {
//        this.reset()
        if (this.$route.name === 'categoryDetail') {
          this.init()
        }
      },
      'queryTotal': function () {
        if (!this.categorySelected) {
          /*
           进一步过滤this.categoryOptions，仅获取查询结果中的类别
           */
          let searchCategories = this.queryTotal.category
          let options = this.categoryOptions
          let ret = []
          options.forEach(data => {
            let val = searchCategories[data.id]
            if (val) {
              this.categoryOptions.filter((e, index, self) => {
                if (e.id === data.id) {
                  ret.push(e)
                  return ret
                }
              })
            }
          })
          this.categoriesOptions = ret
        }
      },
      'categorySelected': 'selectChanged'
    }
  }
</script>

<style scoped>
  .confirm{
    color: white;
  }
  .top{
    margin-top: -0.4rem;
  }
  .bottom{
    margin-bottom: 0.7rem;
  }
  .panel{
    background-color: white;border-left: #DFDFDF 1px solid;width: 85%;
  }
  .checkbox-text{
    background-color: #EEF0F3;
    color: black;
    border-radius: 0.3rem;
    height: 1.6rem;
    width: 100%;
    text-align: center;
  }
  .span-text{
    font-size: 0.65rem;
    margin: 0 auto;
  }
  .inner{
    width: 0px;
  }
  .select{
    color: #0894ec;
    border: #0894ec 0.03rem solid;
    background-color: white;
  }
  .border-bottom{
    border-bottom: none;
  }
  .label{
    margin-left: -8%;
    width:35%;
  }
  .list{
    margin-right: -2%;
  }
</style>



// WEBPACK FOOTER //
// SearchFilterPanel.vue?6d58dca5